module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/shared/promos/2024/blackfridaysale/1138x90/1.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/shared/promos/2024/blackfridaysale/1138x90/1.png
// module id = OvMy
// module chunks = 0